import { useState } from 'react';
import type { PointLead } from './point-card-text';

const SHORT = 220;

/** A linha que o dono lê primeiro no cartão. Texto longo abre com "ver tudo", no mesmo lugar. */
export function PointLeadLine({ lead }: { lead: PointLead }) {
  const [open, setOpen] = useState(false);
  const long = lead.text.length > SHORT;
  return <p className="topic-board-lead" data-testid="point-lead" data-kind={lead.label === 'Seu ato' ? 'owner' : undefined}>
    <strong>{lead.label}:</strong> {long && !open ? `${lead.text.slice(0, SHORT).trimEnd()}…` : lead.text}
    {long ? <button type="button" className="topic-board-lead-more" onClick={() => setOpen(value => !value)}>{open ? 'ver menos' : 'ver tudo'}</button> : null}
  </p>;
}

/** Título do apontamento: três linhas; um toque mostra o texto inteiro no mesmo lugar. */
export function PointTitle({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  return <span className="topic-board-item-text" data-open={open ? 'true' : undefined} role="button" tabIndex={0} aria-expanded={open}
    title={open ? undefined : text} onClick={() => setOpen(value => !value)}
    onKeyDown={event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); setOpen(value => !value); } }}>{text}</span>;
}
